module.exports = __webpack_public_path__ + "img/exclusive-benefits_0.b0684b9e.jpg";